import controller from './categories-slider-filter.controller';
import templateT1 from './templates/categories-slider-filter-t1.view.html';

let CategoriesSliderFilterComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        hijas:'@',
        isProcedure:'<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    return templateT1;
}

export default CategoriesSliderFilterComponent;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/categories-filter/categories-slider-filter/categories-slider-filter.component.js
 **/